import React from 'react'
import { createIcon } from '@mote/ui/components/icon'
import theme from '@mote/ui/theme'
import { defaultProps } from './defaultProps'

export const PlayIconFilled = createIcon({
  displayName: 'PlayIconFilled',
  path: [
    <rect
      x='1.25'
      y='1.25'
      width='77.5'
      height='77.5'
      rx='38.75'
      fill={theme.colors.primary.base}
      stroke='white'
      strokeWidth='2.5'
    />,
    <path
      d='M57.7451 37.2748L33.3725 23.6548C31.3645 22.5417 28.3872 23.6548 28.3872 26.3396V53.5796C28.3872 56.0678 31.1568 57.5739 33.3725 56.3298L57.7451 42.7097C59.8916 41.4656 59.8916 38.519 57.7451 37.2748Z'
      fill='white'
    />
  ],
  viewBox: '0 0 80 80',
  defaultProps: defaultProps
})
